import { db } from '@/shared/firebase/firebase-init';
import positionModel from './position-model';

const KEY_POSITIONS= 'positions'

export default {
  list() {
    return new Promise((resolve) => {
      db.ref(KEY_POSITIONS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_POSITIONS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          reject("Empy category");
        }
        resolve(model)
      })
    });      
  },

  destroy(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_POSITIONS).child(id).set(null, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          resolve()
        }
      })
    })
  },

  update(model) {
    return new Promise((resolve, reject) => {
          db.ref(KEY_POSITIONS).child(model.id).set(positionModel.forUpdate(model), (error) => {
            if (error) {
              // The write failed...
              reject(error)
            } else {
              // Data saved successfully!
              resolve()
            }
          })
      });
  },

  create(model) {
    const modelToSave = {
      ...model,
      id: db.ref(KEY_POSITIONS).push().key
    };
    
    return new Promise((resolve, reject) => {
        db.ref(KEY_POSITIONS).child(modelToSave.id).set(positionModel.forCreate(modelToSave), (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            resolve()
          }
        });
     
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_POSITIONS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          const modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.label = childSnapshot.val().name
          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/position/position-service.js